import { Component, inject } from '@angular/core';
import {
  CardComponent,
  CardContentComponent,
  CardHeaderComponent,
  IconComponent,
} from '@gains-com/ui-angular';
import { DialogRef } from '@angular/cdk/dialog';

@Component({
  selector: 'app-made-in-the-us-dialog',
  imports: [
    CardComponent,
    CardContentComponent,
    CardHeaderComponent,
    IconComponent,
  ],
  templateUrl: './made-in-the-us-dialog.component.html',
  styleUrl: './made-in-the-us-dialog.component.scss',
})
export class MadeInTheUsDialogComponent {
  readonly dialogRef = inject(DialogRef);
}
